export * from './footer.component';


// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/footer/index.ts